import { createContext } from "react";



interface UIContextProps {
    isSideMenuOpen: boolean;
    isSiderCollapsed: boolean;
    isLoading: boolean;
    showError: boolean;
    menuSelect: any;

    //* Methods
    toogleSideMenu: () => void;
    toggleSiderCollapsed: () => void;
    setIsLoading: (isLoading: boolean) => void;
    setShowError: (show: boolean) => void;
    setMenuSelect: (menu: any) => void;
}

export const UIContext = createContext({} as UIContextProps);